export default __webpack_public_path__ + "static/media/css3.4624a929.png";